import { measureLayerIntrinsicSize } from './queries.js';
import { formatIntrinsicSizeValue } from './widgets.js';
import type { AppState } from '../../state/appState.js';
import { getRenderThemeValues } from '../../app/viewportRenderTheme.js';

export function refreshIntrinsicSizeDisplay(appState: AppState): void {
  const inputs = document.querySelectorAll<HTMLInputElement>('[data-intrinsic-dim]');
  if (!inputs.length) return;
  const renderTheme = getRenderThemeValues();
  for (const input of inputs) {
    const [dim, layerId] = input.dataset.intrinsicDim!.split(':');
    const size = measureLayerIntrinsicSize(appState, layerId, renderTheme);
    if (!size) continue;
    input.value = formatIntrinsicSizeValue(dim === 'w' ? size.w : size.h);
  }
}
